import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productsList: [],
  page: 0,
  pageSize: 10,
  hasMore: true,
  totalCount: 0,
  productTypes: [],
  loading: false,
  error: null,
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    setProducts: (state, action) => {
      const { items, pageNumber, totalPages, totalItems } = action.payload;
      state.productsList = items || [];
      state.page = pageNumber || 1;
      state.hasMore = pageNumber < totalPages;
      state.totalCount = totalItems || 0;
      state.error = null;
    },
    appendProducts: (state, action) => {
      const { items, pageNumber, totalPages } = action.payload;
      const uniqueNew = items.filter(
        (prod) => !state.productsList.some((p) => p.id === prod.id)
      );
      state.productsList = [...state.productsList, ...uniqueNew];
      state.page = pageNumber;
      state.hasMore = pageNumber < totalPages;
    },
    clearProducts: (state) => {
      state.productsList = [];
      state.page = 0;
      state.hasMore = true;
      state.totalCount = 0;
    },
    setProductTypes: (state, action) => {
      state.productTypes = action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  clearError,
  setProducts,
  appendProducts,
  clearProducts,
  setProductTypes,
} = inventorySlice.actions;

export default inventorySlice.reducer;
